import React from 'react';

const SearchFilters = ({ searchTerm, filters, onSearch, onFilterChange }) => {
  const categories = [
    'Necklace',
    'Ring',
    'Pendant',
    'Bracelet',
    'Earring',
    'Chain',
    'Bangle',
    'Kamarbandh',
    'Payal',
  ];

  const purityOptions = [
    '24',
    '22',
    '18',
    '16',
    '14'
  ];

  const sortOptions = [
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'price-asc', label: 'Price (Low to High)' },
    { value: 'price-desc', label: 'Price (High to Low)' },
    { value: 'weight-asc', label: 'Weight (Low to High)' },
    { value: 'weight-desc', label: 'Weight (High to Low)' }
  ];

  return (
    <div className="bg-white p-4 rounded-lg shadow-md mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search Input */}
        <div className="col-span-1 md:col-span-2 lg:col-span-1">
          <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-1">
            Search Products
          </label>
          <input
            type="text"
            id="search"
            value={searchTerm || ''}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Search by name..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
          />
        </div>

        {/* Category Filter */}
        <div>
          <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1">
            Category {filters.category && `(${filters.category})`}
          </label>
          <select
            id="category"
            value={filters.category || ''}
            onChange={(e) => onFilterChange('category', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
          >
            <option value="">All Categories</option>
            {categories.map((category) => (
              <option 
                key={category} 
                value={category}
                selected={filters.category === category}
              >
                {category}
              </option>
            ))}
          </select>
        </div>

        {/* Purity Filter */}
        <div>
          <label htmlFor="purity" className="block text-sm font-medium text-gray-700 mb-1">
            Purity
          </label>
          <select
            id="purity"
            value={filters.purity || ''}
            onChange={(e) => onFilterChange('purity', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
          >
            <option value="">All Purity</option>
            {purityOptions.map((purity) => (
              <option key={purity} value={purity}>
                {purity}
              </option>
            ))}
          </select>
        </div>

        {/* Sort Options */}
        <div>
          <label htmlFor="sort" className="block text-sm font-medium text-gray-700 mb-1">
            Sort By
          </label>
          <select
            id="sort"
            value={filters.sort || ''}
            onChange={(e) => onFilterChange('sort', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
          >
            <option value="">Default Sorting</option>
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Add Reset Filters button */}
      {(filters.category || filters.purity || filters.sort || searchTerm) && (
        <div className="mt-4 flex justify-end">
          <button
            onClick={() => {
              onFilterChange('category', '');
              onFilterChange('purity', '');
              onFilterChange('sort', '');
              onSearch('');
            }}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 focus:outline-none"
          >
            Reset Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchFilters;